import { Flex } from '@/ui/Flex/Flex';
import HorizontalDivider from '@/ui/HorizontalDivider';
import { T } from '@/ui/Text/Text';
import React from 'react';
import { useIntl } from 'react-intl';
import { StyledBlockContainer, StyledBlocksSidebar } from './styles';
import { useDnD } from '../DnDContext';
import { initialNodeData } from '../defaultData';
import { sensorNodeComponents, actionNodeComponents } from '../Nodes/types';

function BlocksSidebar({
  sensorNodeAvailability,
  isSaving,
}: {
  sensorNodeAvailability: {
    'sensor-nfcSpecific': boolean;
    'sensor-button': boolean;
    'sensor-buzzer': boolean;
    'sensor-touch': boolean;
  };
  isSaving: boolean;
}) {
  const intl = useIntl();
  const [, setNewNode] = useDnD();

  const onDragStart = (
    event: React.DragEvent<HTMLDivElement>,
    newNode: { type: string; data: any } | string,
  ) => {
    setNewNode(newNode);
    event.dataTransfer.effectAllowed = 'move';
  };

  return (
    <StyledBlocksSidebar data-testid="blocks-sidebar">
      <Flex direction="column" gap={16}>
        <T h4>
          {intl.formatMessage({ defaultMessage: 'Sensors', id: 'I5diuf' })}
        </T>
        {Object.entries(sensorNodeComponents).map(([type, component]) => {
          const disabled =
            !sensorNodeAvailability[
              type as keyof typeof sensorNodeAvailability
            ] || isSaving;

          return (
            <StyledBlockContainer
              key={type}
              style={{ cursor: disabled ? '' : 'grab' }}
              onDragStart={(event) =>
                onDragStart(event, {
                  type,
                  data: initialNodeData[type as keyof typeof initialNodeData],
                })
              }
              draggable={!disabled}
              data-testid={`add-${type}`}
            >
              {React.createElement(component as any, {
                data: initialNodeData[type as keyof typeof initialNodeData],
                disabled,
              })}
            </StyledBlockContainer>
          );
        })}
      </Flex>
      <HorizontalDivider />
      <Flex direction="column" gap={16}>
        <T h4>
          {intl.formatMessage({ defaultMessage: 'Actions', id: 'wL7VAE' })}
        </T>
        {Object.entries(actionNodeComponents).map(([type, component]) => {
          const disabled = isSaving;
          return (
            <StyledBlockContainer
              key={type}
              style={{ cursor: disabled ? '' : 'grab' }}
              onDragStart={(event) =>
                onDragStart(event, {
                  type,
                  data: initialNodeData[type as keyof typeof initialNodeData],
                })
              }
              draggable={!disabled}
              data-testid={`add-${type}`}
            >
              {React.createElement(component as any, {
                data: initialNodeData[type as keyof typeof initialNodeData],
                disabled,
              })}
            </StyledBlockContainer>
          );
        })}
      </Flex>
    </StyledBlocksSidebar>
  );
}

export default BlocksSidebar;
